/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, DatePicker, message, Modal, Form, Select } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import AvatarUplaod from '../../../components/Custom/AvatarUpload'
import ShiftScheduleSelect from '../../../components/Custom/ShiftScheduleSelect'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectShiftSchedule: null,
			editorState: null
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		const { selectedOfficer } = this.props
		if (selectedOfficer) {
			let editorState = null
			const workHistory = selectedOfficer.work_history
			if (workHistory) {
				const contentBlock = htmlToDraft(workHistory)
				if (contentBlock) {
					const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
					editorState = EditorState.createWithContent(contentState)
				}
			}
			this.setState({ editorState, selectShiftSchedule: { uid: selectedOfficer.shift_schedule_uid } })
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { selectShiftSchedule, editorState } = this.state
		const { 
			AuthStore, form, saveBarangayOfficerInPosition, onClose, barangay_term_uid, barangay_uid, selectedBarangayPosition,
			selectedOfficer
		} = this.props
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			const fileList = _.has(values.avatar, 'fileList') ? values.avatar.fileList : []
			const formattedFiles = fileList.map((mFile) => mFile.originFileObj).filter((i) => i !== undefined)
			const files = []
			if (formattedFiles.length > 0) {
				files.push(formattedFiles[formattedFiles.length - 1])
			}
			delete values.avatar

			let work_history = null
			if (editorState) {
				work_history = draftToHtml(convertToRaw(editorState.getCurrentContent()))
			}
			let params = Object.assign({}, values, { 
				files, 
				barangay_uid,
				barangay_term_uid, 
				barangay_position_uid: selectedBarangayPosition.uid,
				birthday: moment(values.birthday).isValid() ? moment(values.birthday).format('YYYY-MM-DD') : null,
				// shift_schedule_uid: selectShiftSchedule.uid,
				work_history
			})
			if (selectedOfficer) {
				params = Object.assign({}, params, { officer_uid: selectedOfficer.uid })
			}
			console.log('params', params)
			// return

			message.loading({ key: 'set_brgy_officer_position', content: 'Saving Officer in Barangay Position, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveBarangayOfficerInPosition(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_brgy_officer_position', content: 'Barangay Officer in position successfully saved.' })
					
					//create audit trail
					const auditParams = {
						module_name: 'Utilities',
						action: (selectedOfficer) ? 'Update' : 'Create',
						message: (selectedOfficer) ? 
							`Update officer ${params.full_name} details` : 
							`Created new officer ${params.full_name}`
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving barangay officer in position')
					message.error({ key: 'set_brgy_officer_position', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { isSaving, editorState } = this.state
		const { AuthStore, visible, onClose, form, selectedBarangayPosition, selectedOfficer } = this.props
		const { getFieldDecorator } = form
		const { barangay_uid } = AuthStore
		
		return (
			<Modal
				title={(selectedOfficer) ? `Update ${selectedBarangayPosition.name} ${selectedOfficer.full_name}` : `Add ${selectedBarangayPosition.name}`}
				// placement="right"
				// // closable={false}
				// onClose={onClose}
				onOk={this.handleSubmit}
				width={'60%'}
				visible={visible}
				onCancel={onClose}
				maskClosable={!isSaving}
				confirmLoading={isSaving}
				destroyOnClose
			>
				<Form onSubmit={this.handleSubmit}>
					<Row type='flex' justify='center'>
						<Form.Item label='Profile Image'>
							{ getFieldDecorator('avatar', {
								//initialValue: (selectedOfficer) ? selectedOfficer.full_name : null,
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<AvatarUplaod user_uid={selectedOfficer ? selectedOfficer.uid : null} />
							)}
						</Form.Item>
					</Row>
					<Row gutter={16}>
						<Col md={12} sm={24}>
							<Form.Item label='Full Name'>
								{ getFieldDecorator('full_name', {
									initialValue: (selectedOfficer) ? selectedOfficer.full_name : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Officer Full Name'/>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Committee Designation'>
								{ getFieldDecorator('committee_designation', {
									initialValue: (selectedOfficer) ? selectedOfficer.committee_designation : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Committee designation'/>
								)}
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col md={6} sm={24}>
							<Form.Item label='Birthday'>
								{ getFieldDecorator('birthday', {
									initialValue: (selectedOfficer && moment(selectedOfficer.birthday).isValid()) ? 
										moment(selectedOfficer.birthday) : moment(),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }} />
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='ID Numer'>
								{ getFieldDecorator('id_number', {
									initialValue: (selectedOfficer) ? selectedOfficer.id_number : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter ID Number'/>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='4-digit Pin Code'>
								{ getFieldDecorator('pin_code', {
									initialValue: (selectedOfficer) ? selectedOfficer.pin_code : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input maxLength={4} placeholder='4-digits Pin code' type='password'/>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='Order'>
								{ getFieldDecorator('order', {
									initialValue: (selectedOfficer) ? selectedOfficer.order : 0,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input type='number' maxLength={4} placeholder='Order'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Emergency Contact Person'>
								{ getFieldDecorator('emergency_contact_person', {
									initialValue: (selectedOfficer) ? selectedOfficer.emergency_contact_person : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Emergency Contact Person'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Emergency Contact Number'>
								{ getFieldDecorator('emergency_contact_number', {
									initialValue: (selectedOfficer) ? selectedOfficer.emergency_contact_number : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Emergency Contact Number'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Emergency Contact Address'>
								{ getFieldDecorator('emergency_contact_address', {
									initialValue: (selectedOfficer) ? selectedOfficer.emergency_contact_address : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Emergency Contact Address'/>
								)}
							</Form.Item>
						</Col>
					</Row>
					{/* <Row gutter={16}>
						<Col md={12} sm={24}>
							<Form.Item label='Shift Schedule'>
								{ getFieldDecorator('shift_name', {
									initialValue: (selectedOfficer) ? `${selectedOfficer.shift_name}` : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<ShiftScheduleSelect 
										barangay_uid={barangay_uid}
										onSelectedItem={(item) => {
											this.setState({ selectShiftSchedule: item })
										}}
									/>
								)}
							</Form.Item>
						</Col>
					</Row> */}
					<Row>
						<Form.Item label='Address'>
							{ getFieldDecorator('address', {
								initialValue: (selectedOfficer) ? selectedOfficer.address : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Address'/>
							)}
						</Form.Item>
					</Row>
					<Row gutter={16}>
						<Col md={8} sm={24}>
							<Form.Item label='Status'>
								{ getFieldDecorator('status', {
									initialValue: (selectedOfficer) ? selectedOfficer.status : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Status' allowClear>
										<Select.Option value='Appointed'>Appointed</Select.Option>
										<Select.Option value='Elected'>Elected</Select.Option>
										<Select.Option value='Job Order'>Job Order</Select.Option>
										<Select.Option value='Casual'>Casual</Select.Option>
										<Select.Option value='Permanent'>Permanent</Select.Option>
										<Select.Option value='Contract of Service'>Contract of Service</Select.Option>
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={16} sm={24}>
							<Form.Item label='Birth Place'>
								{ getFieldDecorator('birth_place', {
									initialValue: (selectedOfficer) ? selectedOfficer.birth_place : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Birth Place'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Blood Type'>
								{ getFieldDecorator('blood_type', {
									initialValue: (selectedOfficer) ? selectedOfficer.blood_type : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Blood Type'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Weight (kgs.)'>
								{ getFieldDecorator('weight', {
									initialValue: (selectedOfficer) ? selectedOfficer.weight : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input type='number' min={0} placeholder='Enter Weight'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Height (cm.)'>
								{ getFieldDecorator('height', {
									initialValue: (selectedOfficer) ? selectedOfficer.height : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input type='number' min={0} placeholder='Enter Height'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='SSS No.'>
								{ getFieldDecorator('sss_no', {
									initialValue: (selectedOfficer) ? selectedOfficer.sss_no : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter SSS number'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='PAGIBIG No.'>
								{ getFieldDecorator('pagibig_no', {
									initialValue: (selectedOfficer) ? selectedOfficer.pagibig_no : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter PAGIBIG number'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='TIN No.'>
								{ getFieldDecorator('tin_no', {
									initialValue: (selectedOfficer) ? selectedOfficer.tin_no : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter TIN number'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='PHILHEALTH No.'>
								{ getFieldDecorator('philhealth_no', {
									initialValue: (selectedOfficer) ? selectedOfficer.philhealth_no : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter PHILHEALTH number'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='GSIS BP.'>
								{ getFieldDecorator('gsis_bp', {
									initialValue: (selectedOfficer) ? selectedOfficer.gsis_bp : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter GSIS BP.'/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='UMID NO.'>
								{ getFieldDecorator('umid_no', {
									initialValue: (selectedOfficer) ? selectedOfficer.umid_no : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter UMID number'/>
								)}
							</Form.Item>
						</Col>
					</Row>
					<Row>
						<Form.Item label='Work History'>
							{ getFieldDecorator('work_history', {
								//initialValue: (selectedOfficer) ? selectedOfficer.work_history : null,
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								//<Input.TextArea rows={16} placeholder='Enter some work history'/>
								<Editor
								 	editorState={editorState}
									toolbarClassName="toolbarClassName"
									wrapperClassName="wrapperClassName"
									editorClassName="editorClassName"
								 	onEditorStateChange={(state) => this.setState({ editorState: state })}
								/>
							)}
						</Form.Item>
					</Row>
				</Form>
				{/* <div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div> */}
			</Modal>
		)
	}
}

const SET_BARANGAY_OFFICER_IN_POSITION = gql`
    mutation setBarangayOfficerByPosition($input: JSON) {
		setBarangayOfficerByPosition(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-term' }),
	inject('AuthStore'),
	graphql(SET_BARANGAY_OFFICER_IN_POSITION, {
		props({ mutate }) {
			return {
				saveBarangayOfficerInPosition(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayPositions','barangayOfficersPerPosition','userAvatar']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
